module.exports = __webpack_public_path__ + "img/achievement2.0e3cb157.jpg";